<template>
    <div class="row">
        <div class="col-12 col-md-5" style="margin: 60px auto 90px;">
            <div style="margin: 0 auto 40px;max-width: 400px;">
                <div class="wfh-title text-center" style="margin-bottom: 21px;">Join the movement</div>
                <div class="wfh-paragraph text-center">Ready to start working remotely? Use these tools like
                    clocking-in, to work efficiently with your team.
                </div>
            </div>

            <div class="ml-auto mr-auto" style="max-width: 400px;">
                <form
                    @submit="activateAccount"
                    action="#"
                    method="post"
                >
                    <div class="mt-30">
                        <label
                            for="email"
                            class="wfh-form-label"
                            :class="{'text-danger': emailInvalid && displayErrors}"
                        >
                            Email Address
                        </label>
                        <input
                            class="form-control wfh-version"
                            :class="{'is-invalid': emailInvalid && displayErrors}"
                            style="background-image: none !important;"
                            type="email"
                            id="email"
                            v-model="email"
                            placeholder="josh@work.com"/>
                        <span v-if="emailInvalid && displayErrors" v-text="emailValidationText"
                              class="wfh-err-label"></span>
                    </div>

                    <div class="mt-30">
                        <label
                            for="name"
                            class="wfh-form-label"
                            :class="{'text-danger': nameInvalid && displayErrors}"
                        >
                            Name
                        </label>
                        <input
                            class="form-control wfh-version"
                            :class="{'is-invalid': nameInvalid && displayErrors}"
                            style="background-image: none !important;"
                            type="text"
                            id="name"
                            v-model="name"/>
                        <span v-if="nameInvalid && displayErrors" v-text="nameValidationText"
                              class="wfh-err-label"></span>
                    </div>

                    <div class="mt-30 position-relative">
                        <label
                            for="password"
                            class="wfh-form-label"
                            :class="{'text-danger': passwordInvalid && displayErrors}"
                        >
                            Password
                        </label>
                        <input
                            ref="passwordField"
                            class="form-control wfh-version"
                            :class="{'is-invalid': passwordInvalid && displayErrors}"
                            style="background-image: none !important;"
                            type="password"
                            id="password"
                            v-model="password"
                            placeholder="Minimum 8 characters"/>
                        <button
                            class="btn btn-link position-absolute"
                            style="padding: 0 !important;top: 37px;right: 16px"
                            @click="togglePasswordView"
                        >
                            <i class="fas"
                               style="color: #303030;"
                               :class="{'fa-eye': !viewPassword, 'fa-eye-slash': viewPassword}"
                            ></i>
                        </button>
                        <span v-if="passwordInvalid && displayErrors" v-text="passwordValidationText"
                              class="wfh-err-label"></span>
                    </div>

                    <div class="mt-30">
                        <label
                            for="company"
                            class="wfh-form-label"
                        >
                            Company
                        </label>
                        <input
                            class="form-control wfh-version"
                            disabled
                            style="background-image: none !important;"
                            type="text"
                            id="company"
                            v-model="company"/>
                    </div>

                    <div class="mt-30">
                        <label
                            for="designation"
                            class="wfh-form-label"
                            :class="{'text-danger': designationInvalid && displayErrors}"
                        >
                            Designation
                        </label>
                        <input
                            class="form-control wfh-version"
                            :class="{'is-invalid': designationInvalid && displayErrors}"
                            style="background-image: none !important;"
                            type="text"
                            id="designation"
                            v-model="designation"/>
                        <span v-if="designationInvalid && displayErrors" v-text="designationValidationText"
                              class="wfh-err-label"></span>
                    </div>

                    <div class="text-center">
                        <button
                            type="submit"
                            :disabled="!isValidated || loading"
                            class="btn wfh-btn-primary position-relative"
                            style="margin-top: 30px;"
                        >
                            <span
                                class="spinner-border position-absolute"
                                role="status"
                                style="left: 16px;top: 10px;"
                                v-show="loading"
                            >
                                <span class="sr-only">Loading...</span>
                            </span>
                            Sign-up
                        </button>
                    </div>
                </form>
            </div>

            <div class="text-center wfh-action-paragraph mt-2">
                Already have an account? <a href="/login" class="wfh-link">Sign-in</a>
            </div>
        </div>
    </div>
</template>

<script>
    import CompanyState from '../Company/NewCompanyState';

    export default {
        props: ['email', 'company'],

        data() {
            return {
                csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                name: '',
                password: '',
                designation: '',
                emailInvalid: false,
                emailValidationText: "",
                passwordInvalid: false,
                passwordValidationText: "",
                designationInvalid: false,
                designationValidationText: "",
                nameInvalid: false,
                nameValidationText: "",
                displayErrors: false,
                viewPassword: false,
                loading: false
            };
        },

        computed: {
            isValidated() {
                CompanyState.user.email = this.email;
                CompanyState.user.password = this.password;

                const checks = [
                    CompanyState.validateEmail(),
                    CompanyState.validatePassword(),
                    this.name !== "",
                    this.designation !== ""
                ];

                this.passwordInvalid = !CompanyState.validatePassword();
                this.passwordValidationText = this.passwordInvalid
                    ? "Password is invalid"
                    : "";
                this.emailInvalid = !CompanyState.validateEmail();
                this.emailValidationText = this.emailInvalid ? "Email is invalid" : "";
                this.nameInvalid = this.name === "";
                this.nameValidationText = this.nameInvalid ? "Name is invalid" : "";
                this.designationInvalid = this.designation === "";
                this.designationValidationText = this.designationInvalid ? "Designation is invalid" : "";

                return checks.length === checks.filter(check => check).length;
            }
        },

        methods: {
            async activateAccount(e) {
                e.preventDefault();

                this.loading = true;
                this.displayErrors = false;

                if (!this.isValidated) {
                    this.displayErrors = true;
                    return;
                }

                const url = '/staffs/invite-activation';

                await axios.post(url, {
                    email: this.email,
                    password: this.password,
                    name: this.name,
                    designation: this.designation
                });

                this.loading = false;
                location.href = '/dashboard';
            },

            togglePasswordView(e) {
                this.viewPassword = !this.viewPassword;
                this.$refs['passwordField'].type = this.viewPassword ? 'text' : 'password';
                e.preventDefault();
            }
        }
    }
</script>

<style scoped>
    .mt-30 {
        margin-top: 30px;
    }
</style>

